import { usePaymentCheckoutRedesignExperiment } from 'experiments/use-payment-checkout-redesign-experiment';
import { useIsDesktopWebBreakpoint } from 'hooks/use-media-query';
import noop from 'utils/noop';

import { PaymentMethodSelectorBottomSheet } from './payment-method-selector-bottom-sheet';
import { PaymentMethodSelectorModal } from './payment-method-selector-modal';
import { IPaymentMethodSelectorProps } from './types';

export function PaymentMethodSelector({
  isOpen,
  onClose,
  onConfirm,
  methods,
  selectedMethodId,
  isReloadDrawer,
  reloadSelectedMethodId = '',
  setIsGiftCardVisible = noop,
}: IPaymentMethodSelectorProps) {
  const isPaymentRedesignEnabled = usePaymentCheckoutRedesignExperiment();
  const isDesktopWeb = useIsDesktopWebBreakpoint();

  if (!isPaymentRedesignEnabled) {
    return null;
  }

  const Drawer =
    isDesktopWeb && isPaymentRedesignEnabled
      ? PaymentMethodSelectorModal
      : PaymentMethodSelectorBottomSheet;

  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      setIsGiftCardVisible={setIsGiftCardVisible}
      methods={methods}
      selectedMethodId={selectedMethodId}
      reloadSelectedMethodId={reloadSelectedMethodId}
      isReloadDrawer={isReloadDrawer}
    />
  );
}
